import gql from 'graphql-tag';

export const GET_EQUIPMENT_VO_OPTIONS = gql`
  query GetEquipmentOptions($VOId: ID) {
    equipments(VOId: $VOId) {
      equipmentId
      year
      make
    }
  }
`;
